export enum IdentificationType {
  ABBYY = 'ABBYY',
  MITEK = 'MITEK'
}
